// Unpublished Work © 2026 Deere & Company.

import {QueryCache, QueryClient} from '@tanstack/react-query';
import {handleQueryError} from '../App/utils/handleError';
import {DEFAULT_STALE_TIME} from './store.constants';

export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: handleQueryError,
    }),
    defaultOptions: {
        queries: {
            staleTime: DEFAULT_STALE_TIME,
            refetchOnWindowFocus: false,
        },
    },
});
